(function (global, factory) {
	typeof exports === 'object' && typeof module !== 'undefined' ? factory() :
	typeof define === 'function' && define.amd ? define(factory) :
	(factory());
}(this, (function () { 'use strict';

module.exports.error = require('./error');
module.exports.eval = require('./eval');
module.exports.parse = require('./parse');
module.exports.print = require('./print');
module.exports.types = require('./types');
module.exports.builders = require('./types').builders;
module.exports.validate = require('./validate');

})));
//# sourceMappingURL=index.js.map
